/* eslint indent: 0 */

import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _each from 'lodash/each';

import Backbone from 'backbone';

import { displayFixedErrorAlertForXhrFail } from 'zoomforth_tools/modern_helpers.js';

const FOLDER_ITEM_TYPE = 'folder';
const SPECIAL_FOLDER_TYPE_PROMPTS = 'prompts';
const SPECIAL_FOLDER_TYPE_PROMPTS_SUBFOLDER = 'prompts_subfolder';
const SPECIAL_FOLDER_TYPE_COPIED_SITE_ASSETS = 'copied_site_assets';
const SPECIAL_FOLDER_TYPE_UPLOADS = 'uploads';

const MediaLibraryFolder = Backbone.Model.extend({

    urlRoot: '/v2/folders', 
    
    initialize: function(){
      this.on('error', function(model, xhr) {
        displayFixedErrorAlertForXhrFail(xhr);
      });
    },
    
    getParents: function() {
      var parentId = this.get('parent_id');
      var parentArray = [];
      var parentFolder;
      
      if(this.isRoot()){
        return parentArray;
      }
      
      while(parentId) {
        parentFolder = this.collection.findWhere({id: parentId}); 
        parentArray.unshift(parentFolder);
        parentId = parentFolder.get('parent_id');  
      } 
      parentArray.unshift(this.collection.getRoot()); 
      
      return parentArray;
    }, 
    
    getParentIds: function() {
      return _map(this.getParents(), function(parentFolder) { 
        return parentFolder.get('id');
      }).join();
    },
    
    idInParentTree: function(id) {
      var parents = this.getParents();
      var parentIds = [];
      _each(parents, function(parentFolder) {
        parentIds.push(parentFolder.get('id'));
      });
      if(_includes(parentIds, id)) {
        return true;
      }
      return false;
    },
    
    isRoot: function() {
      return (this.get('id') === null);
    }, 
    
    isMovable: function() {
      return !this.get('special_folder_type');
    },
    
    isDeletable: function() {
      return !this.get('special_folder_type');
    }, 
    
    isRenamable: function() {
      return (
        this.get('special_folder_type') == SPECIAL_FOLDER_TYPE_PROMPTS_SUBFOLDER || 
        !this.get('special_folder_type')
      );
    },
    
    getChildren: function(){
      return this.collection.getChildrenByFolder(this);
    },

    moveToFolder: function(folderId){
      return this.save(
        {parent_id: folderId}, 
        {patch: true}
      );
    },
    
    rename: function(new_name) {
      return this.save(
        {name: new_name},
        {patch: true}
      );
    },
    
    getFolderId: function(){
      return this.get('parent_id');
    },

    getName: function(){
      return this.get('name');
    },
    
    getItemType: function() {
      return FOLDER_ITEM_TYPE;
    },
    
    isExpandable: function(selectedItemType, selectedItemId) {
      return (
        this.getChildren().length && 
        !(selectedItemType == FOLDER_ITEM_TYPE && this.get('id') == selectedItemId)
      );
    }, 
    
    shouldDisplayInFolderModal: function() {
      return (this.collection.length <= 5 || this.getParents().length <= 1);
    },
    
    isExpanded: function() {
      return (this.collection.length <= 5 || this.getParents().length === 0);
    }, 
    
    isSpecialFolder: function() {
      return (
        this.get('special_folder_type') == SPECIAL_FOLDER_TYPE_PROMPTS ||
        this.get('special_folder_type') == SPECIAL_FOLDER_TYPE_COPIED_SITE_ASSETS  || 
        this.get('special_folder_type') == SPECIAL_FOLDER_TYPE_UPLOADS
      );
    }
    
  });
  
export default MediaLibraryFolder;
